import React from 'react';
import { SvgIcon } from '../../../common/SvgIcon';
import { simpleIconPropsTypes } from '../../propTypes';

export const IconNewDashboard = (props) => {
  const { width = 22, height = 22 } = props;

  return (
    <SvgIcon width={width} height={height} viewBox="0 0 22 22">
      {/* Left tall */}
      <rect x="1.5" y="2" width="8.5" height="12" rx="2.2" fill="currentColor" />

      {/* Top right small */}
      <rect x="12" y="2" width="8.5" height="6" rx="2.2" fill="currentColor" />

      {/* Bottom left small */}
      <rect x="1.5" y="15.5" width="8.5" height="5.5" rx="2.2" fill="currentColor" />

      {/* Bottom right tall */}
      <rect x="12" y="9.5" width="8.5" height="11.5" rx="2.2" fill="currentColor" />
    </SvgIcon>
  );
};

IconNewDashboard.propTypes = simpleIconPropsTypes;
